import { z } from 'zod/v4';
import { CAPA_FINDING_URGENCY_LEVELS } from '../../constants.js';
import { RestrictedFieldSchema } from './create-finding.js';

export const UpdateFindingParamsSchema = z.object({
  id: z.string().min(1),
});
export type UpdateFindingParams = z.infer<typeof UpdateFindingParamsSchema>;

/** Only the fields sent are written. */
export const UpdateFindingRequestSchema = z.object({
  title: z
    .string()
    .min(1, 'Title is required')
    .max(4000, 'Title too long')
    .optional(),
  description: z.string().optional(),
  urgency: z.enum(CAPA_FINDING_URGENCY_LEVELS).optional(),
  impactAreaId: z.string().min(1, 'Impact area ID is required').optional(),
  /** An empty string clears the assignee. */
  assigneeUserId: z.string().optional(),
  /** Any date `Date` can parse; `null` or an empty string clears it. */
  dueDate: z.string().optional().nullable(),
  rootCauseAnalysis: RestrictedFieldSchema,
  genderedImplications: RestrictedFieldSchema,
});
export type UpdateFindingRequest = z.infer<typeof UpdateFindingRequestSchema>;
